import {
  DASHBOARD_FAILED,
  DASHBOARD_SUCCESS,
  HEALTH_DASHBOARD_FAILED,
  HEALTH_DASHBOARD_SUCCESS,
  PERFORMANCE_DASHBOARD_FAILED,
  PERFORMANCE_DASHBOARD_SUCCESS,
  REQUEST_DASHBOARD,
  REQUEST_HEALTH_DASHBOARD,
  REQUEST_PERFORMANCE_DASHBOARD,
  REQUEST_SAFETY_DASHBOARD,
  REQUEST_SECURITY_DASHBOARD,
  SAFETY_DASHBOARD_FAILED,
  SAFETY_DASHBOARD_SUCCESS,
  SECURITY_DASHBOARD_FAILED,
  SECURITY_DASHBOARD_SUCCESS,
} from '../actions/types';

export const dashboardReducer = (
  state = {
    loading: false,
  },
  action,
) => {
  switch (action.type) {
    case REQUEST_DASHBOARD:
      return { loading: true };
    case DASHBOARD_SUCCESS:
      return { loading: false, data: action.payload };
    case DASHBOARD_FAILED:
      return { loading: false };
    default:
      return state;
  }
};

export const healthDashboardReducer = (
  state = {
    loading: false,
  },
  action,
) => {
  switch (action.type) {
    case REQUEST_HEALTH_DASHBOARD:
      return { loading: true };
    case HEALTH_DASHBOARD_SUCCESS:
      return { loading: false, data: action.payload };
    case HEALTH_DASHBOARD_FAILED:
      return { loading: false };
    default:
      return state;
  }
};

export const performanceDashboardReducer = (
  state = {
    loading: false,
  },
  action,
) => {
  switch (action.type) {
    case REQUEST_PERFORMANCE_DASHBOARD:
      return { loading: true };
    case PERFORMANCE_DASHBOARD_SUCCESS:
      return { loading: false, data: action.payload };
    case PERFORMANCE_DASHBOARD_FAILED:
      return { loading: false, data: action.payload };
    default:
      return state;
  }
};

export const safetyDashboardReducer = (
  state = {
    loading: false,
  },
  action,
) => {
  switch (action.type) {
    case REQUEST_SAFETY_DASHBOARD:
      return { loading: true };
    case SAFETY_DASHBOARD_SUCCESS:
      return { loading: false, data: action.payload };
    case SAFETY_DASHBOARD_FAILED:
      return { loading: false };
    default:
      return state;
  }
};

export const securityDashboardReducer = (
  state = {
    loading: false,
  },
  action,
) => {
  switch (action.type) {
    case REQUEST_SECURITY_DASHBOARD:
      return { loading: true };
    case SECURITY_DASHBOARD_SUCCESS:
      return { loading: false, data: action.payload };
    case SECURITY_DASHBOARD_FAILED:
      return { loading: false };
    default:
      return state;
  }
};
